import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

const StyledH6 = styled.h6`
  font-family: ${({ theme }) => theme.secondaryFont};
  font-size: ${rem('17px')};
  font-weight: 600;
  text-transform: uppercase;
  color: #343638;
  margin-bottom: ${rem('16px')};
  margin-top: ${rem('16px')};

  ${({ type }) => (type == 'subsection') && css`
      font-weight: 500
  `}

  ${({ type }) => (type == 'terms') && css`
    font-size: ${rem('15px')};
    font-weight: 500;
    margin-bottom: ${rem('6px')};
    margin-top: ${rem('6px')};
  `}

  ${({ type }) => (type == 'ccpa') && css`
    font-size: ${rem('20px')};
  `}

`

const SectionTitle = ({ type, children }) => {
  return (
    <StyledH6 type={type}>{children}</StyledH6>
  );
};

SectionTitle.propTypes = {
  type: PropTypes.string,
  children: PropTypes.string.isRequired
}

export default SectionTitle;